import { jsx as _jsx } from "react/jsx-runtime";
import { IconAffiliate, IconArrowUpRight, IconBook, IconFacebook, IconGiftSolid, IconLogout, IconLucideArrowRightLeft, IconMessage, IconSettingsGear } from '@wegic/icon';
import { openFeedbackModal } from '@/components/FeedbackModal';
import { FeedbackSource } from '@/components/FeedbackModal/const';
import { WEGIC_AFFILIATE_URL, WEGIC_FACEBOOK_URL, WEGIC_HELP_CENTER_URL } from '@/const';
import { HelpDocsSource, openHelpDocs } from '@/helpers/helpDocs';
import { createDividerMenuItem } from '@/helpers/menuItem';
import { openSettingsModal, SettingsModalSource } from '@/helpers/settingsModal';
import { handleUserLogout } from '@/helpers/user';
import { useReferralModalStore } from '@/stores/referralModal';
export { createDividerMenuItem };
function renderExternalSuffix(options) {
    return /*#__PURE__*/ _jsx(IconArrowUpRight, {
        className: options === null || options === void 0 ? void 0 : options.suffixClassName
    });
}
export function useSettingMenuItem(tab, type) {
    return ()=>{
        return {
            type: 'item',
            key: 'Setting',
            text: intl.get('menu.setting'),
            icon: /*#__PURE__*/ _jsx(IconSettingsGear, {}),
            onClick: ()=>openSettingsModal({
                    type,
                    initialTab: tab,
                    source: SettingsModalSource.UserMenuSettings
                })
        };
    };
}
export function createReferAndEarnMenuItem() {
    return {
        type: 'item',
        key: 'Refer & Earn',
        text: intl.get('menu.referAndEarn'),
        icon: /*#__PURE__*/ _jsx(IconGiftSolid, {}),
        onClick: ()=>useReferralModalStore.getState().open('left_bottom_user_menu')
    };
}
export function createBecomeAffiliateMenuItem(options) {
    return {
        type: 'item',
        key: 'Become an Affiliate',
        text: intl.get('menu.becomeAffiliate'),
        icon: /*#__PURE__*/ _jsx(IconAffiliate, {}),
        suffix: renderExternalSuffix(options),
        onClick: ()=>{
            window.open(WEGIC_AFFILIATE_URL, '_blank');
        }
    };
}
export function createSwitchToWegicV1MenuItem() {
    return {
        type: 'item',
        key: 'Switch to Wegic 1.0',
        text: intl.get('menu.switchToWegicV1'),
        icon: /*#__PURE__*/ _jsx(IconLucideArrowRightLeft, {}),
        onClick: ()=>{
            window.location.href = '/v1/workspace';
        }
    };
}
export function createHelpCenterMenuItem(options) {
    return {
        type: 'item',
        key: 'Help Center',
        text: intl.get('settings.menu.helpCenter'),
        icon: /*#__PURE__*/ _jsx(IconBook, {}),
        suffix: renderExternalSuffix(options),
        onClick: ()=>{
            openHelpDocs(WEGIC_HELP_CENTER_URL, {
                source: HelpDocsSource.DropdownMenu,
                usage: 'SIDEBAR'
            });
        }
    };
}
export function createContactUsMenuItem(options) {
    return {
        type: 'item',
        key: 'Contact Us',
        text: intl.get('settings.menu.contactUs'),
        icon: /*#__PURE__*/ _jsx(IconMessage, {}),
        suffix: renderExternalSuffix(options),
        onClick: ()=>{
            openFeedbackModal(FeedbackSource.DropdownMenu);
        }
    };
}
export function createJoinFacebookMenuItem(options) {
    return {
        type: 'item',
        key: 'facebook',
        text: intl.get('menu.joinFacebook'),
        icon: /*#__PURE__*/ _jsx(IconFacebook, {
            style: {
                fontSize: 18
            }
        }),
        suffix: renderExternalSuffix(options),
        onClick: ()=>window.open(WEGIC_FACEBOOK_URL, '_blank')
    };
}
export function useLogoutMenuItem() {
    return ()=>{
        return {
            type: 'item',
            key: 'logout',
            text: intl.get('menu.logout'),
            icon: /*#__PURE__*/ _jsx(IconLogout, {}),
            status: 'danger',
            onClick: async ()=>{
                handleUserLogout();
            }
        };
    };
}
